import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Fix: CSS zoom causes getBoundingClientRect to return visual px instead of CSS px.
// Libraries like ng-select use getBoundingClientRect for positioning — this patch
// converts visual coordinates back to CSS coordinates so dropdowns align correctly.
const _origGetBoundingClientRect = Element.prototype.getBoundingClientRect;
Element.prototype.getBoundingClientRect = function () {
  const rect = _origGetBoundingClientRect.call(this);
  const zoom = parseFloat(getComputedStyle(document.documentElement).zoom) || 1;
  if (zoom === 1) return rect;
  return new DOMRect(rect.x / zoom, rect.y / zoom, rect.width / zoom, rect.height / zoom);
};

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
